export enum DateTextTypes {
  Date,
  Esg,
}
